import { useEffect, useMemo } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import logo from "../../assets/logo.png";
import logoIcon from "../../assets/logo-icon.png";
import dashboardIcon from "../../assets/dashboard-icon.png";
import uploadDocumentIcon from "../../assets/upload-documents-icon.png";
import reportsIcon from "../../assets/reports-icon.png";
import settingsIcon from "../../assets/settings-icon.png";
import profileIcon from "../../assets/profile-icon.png";
import downArrowIcon from "../../assets/down-arrow-icon.png";
import logoutIcon from "../../assets/logout-icon.png";
import './Sidebar.css';
import React, { useState } from 'react';
import SettingsModal from '../SettingsModal';
import { gsap } from 'gsap';
import Cookies from 'js-cookie';
import { LogOut, Languages } from 'lucide-react';

const translations = {
  en: {
    home: 'Users',
    reports: 'Reports',
    settings: 'Settings',
    dutch: 'Dutch',
    logout: 'Logout'
  },
  nl: {
    home: 'Gebruikers',
    reports: 'Rapporten',
    settings: 'Instellingen',
    dutch: 'Nederlands',
    logout: 'Uitloggen'
  }
};

const Sidebar = ({isDarkMode, setIsDarkMode, chats, setSelectedChat, isDutch, setIsDutch}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const t = translations[isDutch ? 'nl' : 'en'];

  const [showOptions, setShowOptions] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const toggleDutch = () => {
    setIsDutch(!isDutch);
    Cookies.set('isDutch', !isDutch)
  };

  const handleLogout = () => {
    Cookies.remove('token')
    Cookies.remove('isDarkMode')
    Cookies.remove('email')
    Cookies.remove('userId')
    Cookies.remove('accountType')
    navigate('/login');
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    Cookies.set('isDarkMode', !isDarkMode)
  };

  const navLinks = useMemo(() => [
    {
      name: t.home,
      path: '/',
      icon: dashboardIcon
    },
    {
      name: t.reports,
      path: '/reports',
      icon: reportsIcon
    }
  ], [t.home, t.scanAI, t.reports]);

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const sections = document.querySelectorAll('.fadeUp');
    const tl = gsap.timeline();

    sections.forEach(section => {
        tl.to(section, 
            { 
                stagger: 0.2,
                duration: 0.2, 
                opacity: 1, 
                y: 0, 
                ease: "back",
            }
        );
    });
}, [,location]);

  return (
    <div className={`sidebar ${isDarkMode ? 'dark-mode' : ''}`}>
    <div className="sidebar-content">
      <div className="logo fadeUp"
      onClick={() => (navigate('/'))}>
        <img 
          src={logo} 
          alt="logo"
          className="logo-icon"
        />
      </div>

      <nav>
        <ul className="space-y-2">
          {navLinks.map((link) => (
            <li key={link.path} className='fadeUp' >
              <Link
                to={link.path}
                className={`nav-item flex items-center p-2 rounded-lg transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'active text-dark text-primary'
                    : ' '
                }`}
              >
                <img 
          src={link.icon} 
          alt="logo"
          className={`session-icon ${!isActive(link.path) && 'brightness-0'}`}
        />
                <span className={`${isActive(link.path) && 'text-primary font-bold'}`}>{link.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div className="bottom-section">
      {showOptions && (
          <div className="options text-left border rounded-md pt-2">
            <span className="text-left text-xs pl-4">{t.settings}</span>
            <div className='toggle-language options-item cursor-default flex items-center justify-between'>
                <span className='flex items-center gap-2'>
                <Languages className="size-4"/>
              <span className='text-sm'>{t.dutch}</span>
                </span>
                <input
                type="checkbox"
                checked={isDutch}
                onChange={toggleDutch}
                className="theme-checkbox toggle-english"
                />
            </div>
            <span className='options-item logout-option' onClick={handleLogout}>
                <LogOut className="size-4"/>
              <p className='text-sm'>{t.logout}</p>
            </span>
          </div>
        )}
        <div className={`border user-profile ${showOptions && "active"} fadeUp`} onClick={toggleOptions}>
          <span className='truncate'>
            <p className="user-name truncate">{Cookies.get('email')}</p>
          </span>
          <img 
            src={downArrowIcon} 
            alt="down arrow"
            className="down-arrow-icon"
          />
        </div>
        
      </div>
      
      </div>

      <SettingsModal 
        isOpen={isModalOpen} 
        onClose={toggleModal} 
        onToggleDarkMode={toggleDarkMode} 
        isDarkMode={isDarkMode} 
      />
    </div>
  );
};

export default Sidebar;